import styled from '@emotion/styled';
import { Link } from '@fluentui/react-link';
import { blue, grey, tokens } from '@galaxy-react/core';

export const PopoverChipsWrapperStyled = styled('div')({
  display: 'flex',
  padding: '16px',
  gap: '8px',
});

export const PopoverListStyled = styled('ul')({
  padding: `0 ${tokens.spacingVerticalL}`,
  margin: '0',
  listStyle: 'none',
});

export const PopoverLiStyled = styled('li')({
  display: 'flex',
  '&:first-of-type': {
    paddingTop: tokens.spacingHorizontalL,
  },
  '&:last-child': {
    paddingBottom: tokens.spacingHorizontalL,
  },
  paddingTop: tokens.spacingHorizontalS,

  gap: '16px',
});

export const PopoverTypographyStyled = styled('h4')({
  margin: `${tokens.spacingHorizontalL} 0 0`,
  color: blue[700],
});

export const PopoverReportNameStyled = styled('h4')({
  color: blue[700],
});

export const PoppoverReportNameLiStyled = styled('li')({
  padding: '0',
});

export const PopoverContentStyled = styled('div')({
  color: grey[800],
  gap: '16px',
  display: 'flex',
  alignItems: 'center',
  svg: {
    color: blue[700],
  },
});

export const LinkStyled = styled(Link)({
  color: grey[800],
  gap: '16px',
  display: 'flex',
  '&:hover': {
    textDecoration: 'none',
    color: grey[800],
  },
  '&:focus': {
    textDecoration: 'none',
    outline: 'none',
  },
});

export const FooterUlStyled = styled('ul')({
  padding: `${tokens.spacingHorizontalXS} 5px`,
  margin: '0',
  listStyle: 'none',
});

export const FooterliStyled = styled('li')({
  padding: `${tokens.spacingHorizontalS} 11px`,
  '&:hover': {
    background: '#1C365F0A',
    borderRadius: tokens.borderRadiusMedium,
  },
});
